import React from 'react'

const LoadingPage = () => {
    return (
        <div>
            LoadingPage
        </div>
    )
}

export default LoadingPage
